<template>
    <span>
        <span>
            <relative-time-formatter :time="time" v-if="time"></relative-time-formatter><span v-else>{{ $t('site.relativeTime.never' )}}</span>&nbsp;
            <a @click="refreshUser">
                <font-awesome-icon icon="sync" :spin="ajaxActive" v-bind:class="{'redSpinner': isFailed || showError, 'greenSpinner': isSuccessful }"></font-awesome-icon>
            </a>
        </span>

         <v-snackbar
                 color="error"
                 :timeout=12000
                 v-model="showError"
                 multi-line
         >
            {{ errorText }}
        <v-btn dark flat @click.native="showError = false">{{ $t('site.common.close') }}</v-btn>
        </v-snackbar>
    </span>
</template>

<script>
    import axios from 'axios'
    import RelativeTimeFormatter from "./RelativeTimeFormatter"
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

    export default {
        components: {
            RelativeTimeFormatter, FontAwesomeIcon
        },
        name: "elv-refresh-user-icon",
        props: { player: {required:true} },
        data() {
            return {
                ajaxActive: false,
                refreshing: false,
                showError: false,
                isFailed: false,
                isSuccessful: false,
                errorText: this.$i18n.t('site.status.realTimeUpdatesNotAvailableHeadline')
        }
        },
        computed:{
            time: {
                get: function() {
                    //console.log("time for " + this.player.username + _.get(this.player, "cityMapUpdatedAt") || null);
                    return _.get(this.player, "cityMapUpdatedAt") || null;
                }
            }
        },
        methods: {
            refreshUser: function() {
                let self = this;
                this.ajaxActive = true;
                axios.put(`/api/player/${this.player.server}/${this.player.playerId}/refresh`).then( (response) => {
                    // console.log( "Got data in refresher", response.data);
                    // this.player = response.data;
                    // this.time = _.get(response.data, "cityMapUpdatedAt");
                    // TODO Add better error handling here.
                    this.$ga.event('PlayerRefresh', 'RefreshSuccessful', _.get(response, "data.server"), 1);

                    if( response.data.error ) {
                        if(  response.data.isIgnored ) {
                            Event.$emit( "playerRemoved", response.data );
                        }
                    }
                    else {
                        console.log("Emiting playerRefreshed event from Refresh component");
                        this.isSuccessful = true;
                        Event.$emit( "playerRefreshed", response.data);
                    }

                }).catch( (err) => {
                    try {
                        this.isFailed = true;
                        this.showError = true;
                        //this.errorText = "refresh failed'"
                        this.$ga.event('PlayerRefresh', 'RefreshFailed', self.player.server, self.player.playerId);
                    }catch(err) {
                        console.error(err);
                    }
                }).finally( () => {
                    this.ajaxActive = false;
                });
            }
        }

    }
</script>

<style scoped>
    .redSpinner {
        color: red;
    }
    .greenSpinner {
        color: green;
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvRefreshUserIcon.vue